import getIn from 'transmute/getIn';
export const getStatusToggle = getIn(['statusToggle']);